<template>
    <div>
        <!-- TOP BAR -->
        <v-app-bar flat clipped-left app color="white">
            <v-app-bar-nav-icon class="hidden-lg-and-up" @click="showNav = !showNav"></v-app-bar-nav-icon>
            <v-img
                class="mx-4"
                src="../assets/logo.png"
                max-height="50"
                max-width="50"
                contain
                @click="homepage"
                style="cursor: pointer"
            ></v-img>
            <v-app-bar-title :style="{cursor: 'pointer'}" @click="homepage">
            </v-app-bar-title>
            <v-spacer></v-spacer>
            <img src="../assets/Circle-icons-flame.svg" class="mx-4 molten_logo" alt="molten_logo" @click="homepage">
            <span class="molten_title" @click="homepage"> {{ env }} Molten-Core Ad Control</span>
            <v-switch
                v-if="localhost"
                class="ml-10"
                v-model="toggle"
                :false-value="0"
                :true-value="1"
                color="red darken-3"
                hide-details
                label="readOnly"
                @change="updateReadOnly"
            ></v-switch>
            <div class="mx-4" v-if="localhost">bp: {{ $vuetify.breakpoint.name }}</div>
            <div class="mx-4" v-if="localhost">role: {{ $store.state.users.role }}</div>
            <v-spacer></v-spacer>
            <TooltipIcon v-if="role === 'admin'" position="bottom" tooltip="Benutzerverwaltug" to="/users">
                mdi-account-multiple
            </TooltipIcon>
            <TooltipIcon v-if="role === 'admin'" position="bottom" tooltip="Einstellungen" to="/settings">mdi-cog
            </TooltipIcon>
            <TooltipIcon position="bottom" tooltip="Ausloggen" @click="logout">mdi-logout</TooltipIcon>
        </v-app-bar>


        <!-- SIDE BAR -->
        <v-navigation-drawer app clipped v-model="showNav">
            <v-list nav>
                <v-list-item v-for="item in items" :key="item.title" :to="item.route" active-class="active"
                             v-ripple="{ class: `white--text` }">
                    <v-list-item-icon>
                        <v-icon color="grey lighten-2">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title class="grey--text text--lighten-2">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-snackbar bottom right color="success"
                    v-model="logoutSnackbar"
        >
            Sie haben sich erfolgreich ausgeloggt.
            <template v-slot:action="{ attrs }">
                <v-btn icon
                       v-bind="attrs"
                       @click="logoutSnackbar = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import TooltipIcon from "./TooltipIcon";

export default {
    name: "Navbar",
    components: {TooltipIcon},
    beforeDestroy() {
        if (typeof window === 'undefined') return;
    },
    mounted() {
    },
    data() {
        return {
            showNav: true,
            logoutSnackbar: false,
            manualCollapseNave: false,
            toggle: false
        }
    },
    computed: {
        currentBreakpoint() {
            return this.$vuetify.breakpoint.name;
        },
        readOnly() {
            return this.$store.state.readOnly;
        },
        loading() {
            return this.$store.state.loading;
        },
        localhost() {
            return window.location.origin.indexOf('localhost') !== -1;
        },
        role() {
            return this.$store.state.users.role;
        },
        items() {
            if (this.role) {
                let ret = [];
                this.$store.state.navItems.forEach((navItem) => {
                    let route = this.$router.options.routes.find(x => x.path === navItem.route);
                    if (typeof (route.meta) === "undefined" ||
                        typeof (route.meta.access) === "undefined" ||
                        route.meta.access.includes(this.role)) ret.push(navItem);
                })
                return ret
            } else {
                return [this.$store.state.navItems.find(x => x.title === 'Home')];
            }
        },
        env() {
            if (location.origin === 'https://adcontrol-stage.adalliance.io') return 'STAGE - ';
            if (location.origin === 'http://localhost:8080') return 'LOCAL - ';
            else return '';
        }
    },
    methods: {
        homepage() {
            this.$router.push('/')
        },
        logout() {
            // eslint-disable-next-line no-undef
            sso.logout();
            this.logoutSnackbar = true;
            localStorage.removeItem('ssoUser');
            this.$store.dispatch('home/fetchDashboard');
        },
        updateReadOnly(value) {
            this.$store.commit('updateReadOnly', value);
        }
    },
    watch: {
        readOnly() {
            this.toggle = this.readOnly;
        }
    }
}
</script>

<style lang="scss" scoped>

.logo {
    width: 55px;
    height: 70%;
    object-fit: contain;
}

.v-navigation-drawer {
    background: rgb(255, 255, 255);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(215, 3, 100, 0.9) 0%, rgba(117, 43, 119, 1) 55%, rgba(0, 182, 237, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00b6ed", GradientType=1);

    .active {
        ::v-deep .v-icon, ::v-deep .v-list-item__title {
            color: #fff !important;
        }
    }

    .v-list-item--link:before {
        background-color: white;
    }

    .theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before {
        opacity: 0.14;
    }
}

.molten_title, .molten_logo {
    cursor: pointer;
}

.molten_logo {
    height: 35px;
    width: 35px;
}

.molten_title {
    font-family: Montserrat, Arial, Helvetica, sans-serif;
    font-size: 1.3em;
}
</style>